import { Link, useMatch, useResolvedPath } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import { BsListUl } from "react-icons/bs";

export default function AdminLink({ children, icon, to, ...props }: any) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <div
      className={`border-l-2 ${
        match ? " border-toyota bg-white" : "border-gray-50"
      }`}
    >
      <Link to={to}>
        <div className="py-4 px-6 flex items-center text-gray-600">
          <div className="">
            {/* <BsListUl /> */}
            {icon}
          </div>
          <div className="ml-2 hidden sm:block">{children}</div>
        </div>
      </Link>
    </div>
  );
}
